import React from 'react'
import { Box, Typography } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import type { DamageTransaction } from '../../hooks/useMoveOutManagement/useMoveOutManagement'
import { formatCurrency, formatDate } from './utils'

interface DamageTransactionCardProps {
    transaction: DamageTransaction
}

export const DamageTransactionCard: React.FC<DamageTransactionCardProps> = ({
    transaction,
}) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            style={{
                padding: '12px 16px',
                borderBottom: '1px solid #f1f5f9',
            }}
        >
            <Box>
                <Typography variant="body2" style={{ fontWeight: 600 }}>
                    {transaction.charge_code_name}
                </Typography>
                {transaction.description && (
                    <Typography variant="body2" color="textSecondary">
                        {transaction.description}
                    </Typography>
                )}
                {transaction.transaction_date && (
                    <Typography variant="caption" color="textSecondary">
                        {formatDate(transaction.transaction_date)}
                    </Typography>
                )}
            </Box>
            <Box
                display="flex"
                alignItems="center"
                style={{ marginLeft: 16, flexShrink: 0, gap: 6 }}
            >
                {parseFloat(transaction.balance_due) > 0 ? (
                    <>
                        <ErrorOutlineIcon
                            style={{ fontSize: 16, color: '#ef4444' }}
                        />
                        <Typography
                            variant="body2"
                            style={{
                                fontWeight: 600,
                                color: '#ef4444',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Due:{' '}
                            {formatCurrency(
                                parseFloat(transaction.balance_due),
                            )}
                        </Typography>
                    </>
                ) : (
                    <>
                        <CheckCircleOutlineIcon
                            style={{ fontSize: 16, color: '#10b981' }}
                        />
                        <Typography
                            variant="body2"
                            style={{
                                fontWeight: 600,
                                color: '#10b981',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Paid:{' '}
                            {formatCurrency(
                                parseFloat(transaction.amount_paid),
                            )}
                        </Typography>
                    </>
                )}
            </Box>
        </Box>
    )
}
